var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('strong',[_c('span',{ref:_vm.title,class:_vm.id},[_vm._v(_vm._s(_vm.value))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }